<template>
  <div class="canvas-viz">
    <Box
      class="box"
      ref="box"
      @drag-start="setMouseCoord"
      @drag-end="dragEnd"
      :dragBounds="dragBounds"
      :style="{
        position: 'absolute',
        width: coords[getCountryId].artBoard.width * scaleFactor + 'px',
        height: coords[getCountryId].artBoard.height * scaleFactor + 'px',

        top: `${boxTranslate.y -
          (coords[getCountryId].artBoard.height * scaleFactor) / 2 +
          viewPortMinDimensions.height / 2}px `,
        left: `${boxTranslate.x -
          (coords[getCountryId].artBoard.width * scaleFactor) / 2 +
          viewPortMinDimensions.width / 2}px `,
        transition: `all ${panActive ? panDuration / 1000 : 0}s ease`
      }"
    >
      <div
        class="paintings-container"
        :style="{
          transform: `scale(${scaleFactor})`
        }"
        @click="deselectMuseum"
      >
        <CanvasImage
          class="paint-box"
          v-for="paint in paintings"
          :key="paint.id"
          @click="canvasSetPaint(paint, $event)"
          :paint="paint"
          :style="{
            width: findCoord(paint.id).width + 'px',
            height: findCoord(paint.id).height + 'px',
            left: findCoord(paint.id).x + 'px',
            top: findCoord(paint.id).y + 'px',
            opacity: getMuseum === null || paint.museum === getMuseum ? 1 : 0.2,
            pointerEvents:
              getMuseum === null || paint.museum === getMuseum ? 'all' : 'none',
            cursor:
              getMuseum === null || paint.museum === getMuseum
                ? 'pointer'
                : 'initial'
          }"
        >
        </CanvasImage>
      </div>
    </Box>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import posed from "vue-pose";
import CanvasImage from "@/components/CanvasImage.vue";
import coords from "@/assets/content/coords.json";

export default {
  name: "canvasViz",
  data() {
    return {
      visibiltyInterval: null,
      updateVisibilityInterval: 500,
      visiblePaintings: [],
      viewPortMinDimensions: { width: 0, height: 0 },
      scaleFactor: 0,
      dragging: false,
      dragStartEvent: null,
      coords,
      boxTranslate: { x: 0, y: 0 },
      tweenedBoxTranslateX: 0,
      tweenedBoxTranslateY: 0,
      boxTransform: { x: 0, y: 0 },
      panActive: false,
      panDuration: 1000,
      baseUrl: process.env.BASE_URL
    };
  },
  created() {
    this.setDimensions();
    window.addEventListener("resize", () => {
      this.setDimensions();
    });
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.setVisibility();
    // });
  },
  watch: {
    getCountryId() {
      this.setDimensions();
    },
    getMuseum(museum) {
      if (museum !== null) {
        let highlightedPaints = _.filter(
          this.paintings,
          d => d.museum === this.getMuseum
        );
        if (highlightedPaints.length === 1) {
          // One paint
          let coords = this.findCoord(highlightedPaints[0].id);
          this.highlightedPaintsCoord = coords;
          this.panTo(coords);
        } else if (highlightedPaints.length > 1) {
          // More than one
          let coords = _.find(
            this.coords[this.getCountryId].museums,
            museum => museum.id === this.getMuseumId
          );

          this.panTo({ ...coords, width: 0, height: 0 });
        }
      } else {
        // this.panTo({
        //   width: 0,
        //   height: 0,
        //   x: this.coords[this.getCountryId].artBoard.width / 2,
        //   y: this.coords[this.getCountryId].artBoard.height / 2
        // });
      }
    }
    // boxTranslate(oldValue, newValue) {
    // this.setVisibility();
    // }
  },
  computed: {
    paintings() {
      return _.filter(this.$ml.get("data"), d => d.country === this.getCountry);
    },
    translateCoord() {
      let res = {
        x: this.boxTransform.x / this.scaleFactor,
        y: this.boxTransform.y / this.scaleFactor
      };

      let boxPosition = {
        x:
          this.tweenedBoxTranslateX -
          (this.coords[this.getCountryId].artBoard.width * this.scaleFactor) /
            2 +
          this.viewPortMinDimensions.width / 2,
        y:
          this.tweenedBoxTranslateY -
          (this.coords[this.getCountryId].artBoard.height * this.scaleFactor) /
            2 +
          this.viewPortMinDimensions.height / 2
      };

      res = {
        x: res.x - boxPosition.x / this.scaleFactor,
        y: res.y - boxPosition.y / this.scaleFactor
      };

      return res;
    },
    ...mapGetters([
      "getCountry",
      "getCountryId",
      "getMuseum",
      "getMuseumId",
      "getwidgetViewed"
    ])
  },
  methods: {
    setDimensions() {
      let viewPortMinDimension = Math.min(
        window.innerWidth,
        window.innerHeight
      );
      this.viewPortMinDimensions = {
        width: window.innerWidth,
        height: window.innerHeight
      };

      this.scaleFactor = viewPortMinDimension / 100;

      this.dragBounds = {
        top:
          -(this.coords[this.getCountryId].artBoard.height * this.scaleFactor) /
          2,
        left:
          -(this.coords[this.getCountryId].artBoard.width * this.scaleFactor) /
          2,
        bottom:
          (this.coords[this.getCountryId].artBoard.height * this.scaleFactor) /
          2,
        right:
          (this.coords[this.getCountryId].artBoard.width * this.scaleFactor) / 2
      };
    },
    findCoord(id) {
      let res = _.find(this.coords[this.getCountryId].coord, d => d.id === id);

      return res ? res : { width: 0, height: 0, x: 0, y: 0 };
    },
    findImage(id) {
      return _.find(this.images, image => id === image.id);
    },
    setMouseCoord(e) {
      this.dragStartEvent = e;
      this.dragging = true;
    },
    canvasSetPaint(paint, e) {
      if (
        e.clientX === this.dragStartEvent.clientX &&
        e.clientY === this.dragStartEvent.clientY
      ) {
        let coords = this.findCoord(paint.id);
        this.panTo(coords);
        setTimeout(() => {
          this.setPaint(paint);
        }, this.panDuration);
      }
    },
    setBoxTransform() {
      if (this.$refs.box) {
        let elem = this.$refs.box.$el;

        let transform;
        if (elem.style.transform !== "none") {
          transform = {
            x: -elem.style.transform.split("(")[1].split("px")[0],
            y: -elem.style.transform.split("(")[2].split("px")[0]
          };
        } else {
          transform = { x: 0, y: 0 };
        }
        this.boxTransform = transform;
      }
    },
    panTo(coords) {
      let artBoard = this.coords[this.getCountryId].artBoard;
      let artBoardCenter = {
        x: (artBoard.width / 2) * this.scaleFactor,
        y: (artBoard.height / 2) * this.scaleFactor
      };
      let paintCenter = {
        x: (coords.x + coords.width / 2) * this.scaleFactor,
        y: (coords.y + coords.height / 2) * this.scaleFactor
      };
      let difference = {
        x: artBoardCenter.x - paintCenter.x,
        y: artBoardCenter.y - paintCenter.y
      };

      let elem = this.$refs.box.$el;

      let transform;
      if (elem.style.transform !== "none") {
        transform = {
          x: +elem.style.transform.split("(")[1].split("px")[0],
          y: +elem.style.transform.split("(")[2].split("px")[0]
        };
      } else {
        transform = { x: 0, y: 0 };
      }

      let computedDifference = {
        x: difference.x - transform.x,
        y: difference.y - transform.y
      };

      this.boxTranslate = computedDifference;

      this.dragBounds = {
        top: -artBoardCenter.y - computedDifference.y,
        left: -artBoardCenter.x - computedDifference.x,
        bottom: artBoardCenter.y - computedDifference.y,
        right: artBoardCenter.x - computedDifference.x
      };

      this.panActive = true;
      setTimeout(() => {
        this.panActive = false;
      }, this.panDuration);
    },
    isVisible(id) {
      if (this.$refs.box) {
        let coords = this.findCoord(id);

        let artBoard = this.coords[this.getCountryId].artBoard;
        let artBoardCenter = {
          x: (artBoard.width / 2) * this.scaleFactor,
          y: (artBoard.height / 2) * this.scaleFactor
        };
        let paintCoords = {
          x: coords.x * this.scaleFactor,
          y: coords.y * this.scaleFactor
        };

        const differenceX = x => artBoardCenter.x - x;
        const differenceY = y => artBoardCenter.y - y;

        let newPaintCoords = {
          x1: paintCoords.x,
          y1: paintCoords.y,
          x2: paintCoords.x + coords.width * this.scaleFactor,
          y2: paintCoords.y,
          x3: paintCoords.x + coords.width * this.scaleFactor,
          y3: paintCoords.y + coords.height * this.scaleFactor,
          x4: paintCoords.x,
          y4: paintCoords.y + coords.height * this.scaleFactor
        };

        let elem = this.$refs.box.$el;

        let transform;
        if (elem.style.transform !== "none") {
          transform = {
            x: +elem.style.transform.split("(")[1].split("px")[0],
            y: +elem.style.transform.split("(")[2].split("px")[0]
          };
        } else {
          transform = { x: 0, y: 0 };
        }

        let newDifference = {
          x1:
            differenceX(newPaintCoords.x1) - transform.x - this.boxTranslate.x,
          y1:
            differenceY(newPaintCoords.y1) - transform.y - this.boxTranslate.y,
          x2:
            differenceX(newPaintCoords.x2) - transform.x - this.boxTranslate.x,
          y2:
            differenceY(newPaintCoords.y2) - transform.y - this.boxTranslate.y,
          x3:
            differenceX(newPaintCoords.x3) - transform.x - this.boxTranslate.x,
          y3:
            differenceY(newPaintCoords.y3) - transform.y - this.boxTranslate.y,
          x4:
            differenceX(newPaintCoords.x4) - transform.x - this.boxTranslate.x,
          y4: differenceY(newPaintCoords.y4) - transform.y - this.boxTranslate.y
        };

        if (
          (Math.abs(newDifference.x1) < window.innerWidth / 2 ||
            Math.abs(newDifference.x2) < window.innerWidth / 2 ||
            Math.abs(newDifference.x3) < window.innerWidth / 2 ||
            Math.abs(newDifference.x4) < window.innerWidth / 2) &&
          (Math.abs(newDifference.y1) < window.innerHeight / 2 ||
            Math.abs(newDifference.y2) < window.innerHeight / 2 ||
            Math.abs(newDifference.y3) < window.innerHeight / 2 ||
            Math.abs(newDifference.y4) < window.innerHeight / 2)
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    setVisibility() {
      let res = _.clone(this.visiblePaintings);
      _.forEach(this.paintings, paint => {
        if (this.isVisible(paint.id) && !res.includes(paint.id)) {
          res.push(paint.id);
        }
      });

      if (!_.isEqual(res, this.visiblePaintings)) {
        this.visiblePaintings = res;
      }
    },
    dragEnd() {
      this.dragging = false;
    },
    deselectMuseum(e) {
      if (
        e.target.tagName.toLowerCase() !== "img" &&
        !e.target.classList.contains("canvas-image")
      )
        this.setMuseum(null);
    },
    ...mapActions(["setPaint", "setMuseum"])
  },
  components: {
    CanvasImage,
    Box: posed.div({
      draggable: true,
      dragEnd: {
        transition: { type: "decay", power: 0.1 }
      }
    })
  }
};
</script>

<style lang="scss" scoped>
.canvas-viz {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  .box {
    top: -50%;
    left: -25%;
    .paintings-container {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      transform-origin: 0 0;
      .paint-box {
        position: absolute;
      }
    }
  }
}
</style>
